import { Box, IconButton, List, ListItem, Menu, MenuItem, Tooltip, Typography } from '@mui/material'
import React, { useContext, useState } from 'react'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { ThemeContext } from '../../context/ThemeContext';
import { useTranslation } from 'react-i18next';
import EditAlertDialog from '../../components/tab/tabview/alert/EditAlertDialog';
import DeleteAlert from '../../components/tab/tabview/alert/DeleteAlert';
import { useDispatch, useSelector } from 'react-redux';
import { MdOutlineEdit } from "react-icons/md";
import { MdDeleteOutline } from "react-icons/md";
import { deleteAlert, updateAlert } from '../../api/request/dashboard/dashboard';
import { deleteAlertData, updateAlertData } from '../../store/Slices/alertSlice';
import toast from 'react-hot-toast';
import NewAlert from '../components/modals/NewAlert';
import { IoAddSharp } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { MdOutlineNotificationsActive } from "react-icons/md";

export default function Alert() {
  const { darkMode } = useContext(ThemeContext)
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const { symbols } = useSelector(state => state.watchlist)
  const { alert: alertData } = useSelector(state => state.alert);
  const alerts = Array.isArray(alertData) ? alertData : [];
  const [selectedAlert, setSelectedAlert] = useState(null);
  const accountId = localStorage.getItem("accountID");
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = useState(null);
  const conditionMap = {
    1: "condition_bid_gt",
    2: "condition_bid_lt",
    3: "condition_ask_gt",
    4: "condition_ask_lt",
    5: "condition_balance_gt",
    6: "condition_balance_lt",
    7: "condition_equity_gt",
    8: "condition_equity_lt",
    9: "condition_marginlevel_gt",
    10: "condition_marginlevel_lt",
    11: "condition_pl_gt",
    12: "condition_pl_lt",
  };
  const handleEditClick = (alert) => {
    setSelectedAlert(alert);
    setEditOpen(true);
  };

  const handleDeleteClick = (alert) => {
    setSelectedAlert(alert);
    setDeleteOpen(true);
  };
  const handleDelete = async () => {
    if (!selectedAlert) {
      console.error("No alert selected for deletion.");
      return;
    }

    let data = { id: selectedAlert.id, accountId };

    try {
      await deleteAlert(data);
      dispatch(deleteAlertData(selectedAlert.id))
      toast.success("Alert deleted successfully!");
      setDeleteOpen(false);;
    } catch (error) {
      console.error("Error deleting alert:", error);
      toast.error("Failed to delete alert.");
    }
  };
  const handleUpdate = async (updatedAlert) => {
    try {
      const sanitizedPayload = {
        id: updatedAlert.id,
        accountId: Number(updatedAlert.accountId),
        symbolId: updatedAlert.symbolId ? Number(updatedAlert.symbolId) : null,
        condition: updatedAlert.condition,
        type: updatedAlert.type,
        value: updatedAlert.value,
        enabled: updatedAlert.enabled,
        hitPrice: updatedAlert.hitPrice ? updatedAlert.hitPrice : null,
      };

      const response = await updateAlert(sanitizedPayload);
      if (response.status === 200) {
        toast.success("Alert updated successfully!");
        dispatch(updateAlertData(alert.map(alert => alert.id === updatedAlert.id ? updatedAlert : alert)));
        setEditOpen(false);
      }
    } catch (error) {
      console.error("Error updating alert:", error);
      toast.error("Failed to update alert.");
    }
  };
  const handleMenuOpen = (event, alert) => {
    setAnchorEl(event.currentTarget);
    setSelectedAlert(alert);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedAlert(null);
  };
  return (
    <>
      {!open && (
        <Box display="flex" flexDirection="column" height="100vh">
          <Box display="flex" alignItems="center" justifyContent="space-between" px={2} py={1}>
            <Box display="flex" alignItems="center">
              <IconButton onClick={() => navigate('/quote')}><ArrowBackIosNewIcon fontSize="small" /></IconButton>
              <Typography fontSize={18} fontWeight={600} ml={1}>{t('alert')}</Typography>
            </Box>
            <IoAddSharp style={{ fontSize: 20 }} onClick={() => setOpen(true)} />
          </Box>

          <List sx={{ backgroundColor: darkMode ? "#151924" : "#fff", padding: 0 }}>
            {alerts.map((item, index) => {
              const isHit = !item.enabled;
              const symbolName = symbols?.[item.symbolId]?.name || "";
              const price = item.value;
              const conditionText = t(conditionMap[item.condition]);
              const hitInfo = isHit ? `${t('alertHit')} ➜ ${item.hitPrice}` : '';

              return (
                <ListItem onClick={(e) => handleMenuOpen(e, item)} key={index} sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, px: 2, py: 1.5, borderBottom: `1px solid ${darkMode ? 'var(--borderDark)' : '#eee'}`, }}>
                  <Box mt={0.5}><MdOutlineNotificationsActive style={{ fontSize: 22, color: isHit ? "gray" : "#333" }} /></Box>

                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="subtitle2" fontWeight={600} sx={{ fontSize: 14, color: darkMode ? "#fff" : "#000" }}>{symbolName} {conditionText} <span style={{ fontWeight: 600 }}>{price}</span></Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>{hitInfo}</Typography>
                  </Box>
                </ListItem>
              );
            })}
          </List>

        </Box>
      )}
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose} PaperProps={{ elevation: 3, sx: { minWidth: 130 } }} anchorOrigin={{ vertical: "top", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }}>
        <MenuItem onClick={() => { handleEditClick(selectedAlert); handleMenuClose(); }}>
          <Box display="flex" alignItems="center" justifyContent='space-between' sx={{ width: '100%' }}>
            <Typography>Edit</Typography>
            <MdOutlineEdit style={{ fontSize: 22 }} />
          </Box>
        </MenuItem>
        <MenuItem onClick={() => { handleDeleteClick(selectedAlert); handleMenuClose(); }}>
          <Box display="flex" alignItems="center" justifyContent='space-between' sx={{ width: '100%' }}>
            <Typography>Delete</Typography>
            <MdDeleteOutline style={{ fontSize: 20 }} />
          </Box>
        </MenuItem>
      </Menu>
      {open && (<NewAlert open={open} onClose={() => setOpen(false)} />)}
      <EditAlertDialog open={editOpen} handleClose={() => setEditOpen(false)} alertData={selectedAlert} symbolData={symbols} handleUpdate={handleUpdate} />
      <DeleteAlert open={deleteOpen} handleClose={() => setDeleteOpen(false)} handleDelete={handleDelete} />
    </>
  )
}
